import React, { useEffect } from "react";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

function KeyboardListener() {
  useEffect(() => {
    Keyboard.setAccessoryBarVisible({ visible: true });

    Keyboard.addListener("keyboardWillShow", info => {
      let bodyInitialOffsetHeight = localStorage.getItem(
        "bodyInitialOffsetHeight",
      );

      if (!bodyInitialOffsetHeight) {
        bodyInitialOffsetHeight = document.body.offsetHeight;
        localStorage.setItem(
          "bodyInitialOffsetHeight",
          document.body.offsetHeight,
        );
      }

      const screenSize = bodyInitialOffsetHeight - info.keyboardHeight;

      document.body.style.height = `${screenSize}px`;

      const messagesListWrapper = document.getElementsByClassName(
        "messages-list-wrapper",
      );
      const textArea = document.getElementsByClassName(
        "message-form-mobile--content",
      );
      const replyDiv = document.getElementsByClassName("message-reply-mobile");

      if (
        Capacitor.platform === "ios" &&
        messagesListWrapper.length &&
        document.activeElement.id === "new_message_form_content"
      ) {
        let offset = 80;

        if (
          window.matchMedia("(max-device-width: 380px)").matches &&
          bodyInitialOffsetHeight <= 670
          //667px - iphone 7, 8
          // 812px - iphone 12 mini
        ) {
          offset = 110;
        }

        messagesListWrapper[0].style.height = `calc(${screenSize}px - ${textArea[0]
          .clientHeight +
          offset +
          (replyDiv.length > 0
            ? replyDiv[0].clientHeight
            : 0)}px - env(safe-area-inset-top) - env(safe-area-inset-bottom))`;
      }

      // resize body to total size less keyboard (allow scroll)
      if (
        document?.activeElement &&
        document.activeElement.getBoundingClientRect().bottom > screenSize
      ) {
        document.activeElement.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }
    });

    Keyboard.addListener("keyboardWillHide", info => {
      const messagesListWrapper = document.getElementsByClassName(
        "messages-list-wrapper",
      );
      const textArea = document.getElementsByClassName(
        "message-form-mobile--content",
      );
      const replyDiv = document.getElementsByClassName("message-reply-mobile");

      if (Capacitor.platform === "ios" && messagesListWrapper.length) {
        messagesListWrapper[0].style.height = `calc(100vh - ${textArea[0]
          .clientHeight +
          113 +
          (replyDiv.length > 0
            ? replyDiv[0].clientHeight
            : 0)}px - env(safe-area-inset-top) - env(safe-area-inset-bottom))`;
      }
    });
  }, []);

  return <></>;
}

export default KeyboardListener;
